<template>
  <video :src="videoUrl" ref="videoRef"></video>
</template>
<script setup lang="ts">
import { VideoHTMLAttributes } from 'vue'

const props = defineProps<{ src: VideoHTMLAttributes['src'] }>()

const canUse = ref(true);
const videoRef = ref<HTMLVideoElement>();

defineExpose({
  videoRef,
})

const videoUrl = computed(() => {
  if (!videoRef.value) return '';
  if (!canUse.value) {
    console.log(videoRef.value, `实例视频现已置空，原视频url:${props.src}`)
    return '';
  }
  console.log(videoRef.value, `实例视频url置为：${props.src}`)
  return props.src;
});

const visibleChange = () => {
  if (document?.visibilityState === 'visible') {
    canUse.value = true;
  }
  if (document?.visibilityState === 'hidden') {
    canUse.value = false;
  }
}

window.addEventListener('beforeunload', () => {
  canUse.value = false;
});

onMounted(() => {
  canUse.value = true;
  document?.addEventListener('visibilitychange', visibleChange);
});
onBeforeUnmount(() => {
  canUse.value = false;
  document?.removeEventListener('visibilitychange', visibleChange);
})

</script>
